const zh = {
    "sc_title": "安全中心",
    "sc_subtitle": "GaiaShield集成安全层",
    "sc_tab_status": "🛡️ 保护状态",
    "sc_tab_events": "📋 安全日志",
    "sc_tab_node": "⚙️ 节点安全",
    "sc_loading": "正在加载安全数据...",
    "sc_status_secured": "系统状态：账户已受保护",
    "sc_status_warning": "系统状态：警告激活",
    "sc_desc_secured": "没有活动的严重安全警告。GaiaShield正在积极监控您的账户。",
    "sc_desc_warning": "注意：有活动的安全事件需要您的关注。",
    "sc_account_protection": "账户保护",
    "sc_message_protection": "消息保护",
    "sc_audits": "安全 Center 审计",
    "sc_active": "活动",
    "sc_failed_logins": "登录失败",
    "sc_tamper_checks": "篡改检查",
    "sc_blocked_replays": "阻止的重放",
    "sc_last_check": "上次检查",
    "sc_just_now": "刚刚",
    "sc_open_warnings": "未处理警告",
    "sc_btn_acknowledge": "确认",
    "sc_filter_severity": "严重程度",
    "sc_filter_category": "类别",
    "sc_filter_hide_ack": "隐藏已确认",
    "sc_btn_export": "导出",
    "sc_col_details": "详情",
    "sc_col_time": "时间",
    "sc_col_status": "状态",
    "sc_col_action": "操作",
    "sc_no_events": "未找到安全事件。",
    "sc_node_title": "节点运营商安全控制台",
    "sc_system_health": "系统健康",
    "sc_last_audit": "上次审计",
    "sc_packed_logs": "打包日志",
    "sc_unconfirmed_events": "未确认事件",
    "sc_operator_action": "需要运营商操作",
    "sc_all_ok": "全部正常",
    "sc_critical_events": "严重系统事件",
    "ac_title": "治理与滥用举报中心",
    "ac_subtitle": "GaiaCom 治理与滥用共识",
    "ac_tab_my_reports": "我的举报",
    "ac_tab_queue": "审核队列",
    "ac_tab_operator": "节点运营商",
    "ac_tab_transparency": "邦联与透明度",
    "ac_loading": "正在加载数据...",
    "ac_reported_cases": "举报的案例",
    "ac_no_reports": "您尚未提交任何举报。",
    "ac_case_details": "案例详情",
    "ac_appeal_submit": "提交申诉",
    "ac_appeal_status": "申诉状态",
    "ac_appeal_reason": "申诉原因",
    "ac_appeal_statement": "申诉陈述",
    "ac_btn_appeal": "发送申诉",
    "ac_trusted_reviewer_queue": "受信任审核员队列",
    "ac_case_review": "审查案例",
    "ac_review_category": "推荐类别",
    "ac_review_severity": "推荐严重程度",
    "ac_review_action": "推荐操作",
    "ac_review_reason": "审核员意见",
    "ac_btn_submit_review": "提交审核",
    "ac_node_operator_dashboard": "节点运营商仪表板",
    "ac_apply_action": "执行操作（重写）",
    "ac_target_type": "目标类型",
    "ac_target_id": "目标ID（GaiaID或频道ID）",
    "ac_suspend": "暂停活动",
    "ac_reason": "官方原因",
    "ac_btn_apply": "强制执行操作",
    "ac_transparency_title": "共识与透明日志",
    "ac_transparency_desc": "所有受监管频道和身份的公开可查看快照证明。",
    "ac_btn_snapshot": "创建透明度快照",
    "search_placeholder": "按主题、发件人、正文搜索邮件...",
    "abuse_center_title": "滥用申诉中心",
    "abbrechen": "取消",
    "active_identities": "主动身份",
    "active_identity": "主动身份",
    "add_btn": "添加",
    "add_contact_title": "添加联系人",
    "admin": "行政",
    "adressbuch": "目录",
    "aktiviert": "启用",
    "an": "到",
    "anonymous_sender": "匿名发件人",
    "antworten": "回答",
    "attachment_gaia_hint": "GaiaCOM 附件保持端到端加密。",
    "attachment_smtp_hint": "旧版 SMTP 会阻止可执行/类似脚本的附件，并将电子邮件保存为不安全的。",
    "attachments": "附件",
    "auffaellig": "显",
    "auth_beta_notice": "Beta 测试阶段：GaiaCOM 正在积极测试。可能会出现错误；确保重要种子的安全并仔细审查机密工作流程。",
    "auth_btn_login": "加载身份并登录",
    "auth_btn_register": "注册并创建加密货币",
    "auth_copied": "已复制",
    "auth_copy_seed": "复制种子",
    "auth_generate_seed": "生成种子",
    "auth_headline": "GaiaCOM 是第一个为人类构建的量子安全电子邮件协议和通信系统。",
    "auth_kicker": "后量子安全通信",
    "auth_mnemonic": "助记词",
    "auth_mnemonic_placeholder": "12个单词，中间用空格隔开...",
    "auth_password": "密码",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "私钥不会离开您的设备。只有预期的接收者才能解密内容。",
    "auth_proof_gaiadata_desc": "零知识：您仍然可以控制自己的数据。元数据被最小化并且不用作纯文本配置文件。",
    "auth_proof_gaiadrop_desc": "外部人员无需帐户即可向您的 GaiaID 发送机密短信。",
    "auth_proof_gaiaproof_desc": "传送和完整性证据表明密文、发送者和时间戳未被篡改。",
    "auth_proof_gaiavault_desc": "私人笔记、恢复笔记和安全记录保持本地加密。",
    "auth_proof_hybrid_desc": "Quantum Shield：使用 ML-KEM 和 X25519 的混合加密可防御当今的攻击和“先存储后解密”的风险。",
    "auth_secure_mail": "安全的量子联合邮件",
    "auth_subline": "GaiaCOM 是一个用于电子邮件、聊天、危机室、GaiaDrop 和本地安全文件的量子安全通信系统。私钥保留在您的设备上，内容经过端到端加密，并且无需纯文本即可导出证据。",
    "auth_success_btn": "立即登录",
    "auth_success_text": "您的 GaiaCOM 帐户已创建。密钥是从您的种子本地派生的，并未存储在服务器上。",
    "auth_success_title": "注册成功",
    "auth_tab_drop": "盖亚水滴",
    "auth_tab_login": "登录/帐户",
    "auth_toggle_login": "帐户已存在",
    "auth_toggle_register": "创建新帐户",
    "auth_usecase_text": "适用于律师、公司、当局、记者、举报人和私人保安案件。",
    "auth_usecase_title": "专为敏感通信而打造",
    "auth_username": "用户名",
    "auth_username_placeholder": "输入姓名...",
    "auth_value_chat": "端到端聊天",
    "auth_value_drop": "安全投递",
    "auth_value_mail": "安全邮件",
    "auth_value_rooms": "盖亚客房",
    "bestaetigen": "确认",
    "bestaetigt": "确认的",
    "bio_status": "传记/现状",
    "biography": "传",
    "change_password_desc": "更改您的服务器端登录密码。您的本地恢复短语仍然受到保管库/解锁密码的单独保护。",
    "change_password_menu_desc": "更新 GaiaCOM 登录密码。",
    "change_password_title": "更改密码",
    "channel_id": "通道号",
    "channel_name_label": "频道名称",
    "chat_deleted_hidden": "聊天记录已删除并隐藏。",
    "chat_input_placeholder": "输入安全消息...",
    "chat_start_hint": "开始对话！所有聊天消息均经过量子安全端到端加密。",
    "choose_avatar": "选择头像",
    "ciphertext_hash": "密文哈希",
    "clear_chat": "空聊",
    "clear_for_everyone": "给大家空着",
    "clear_for_me": "只为我而空",
    "click_to_write_mail": "点击写一封电子邮件",
    "click_top_right": "点击右上角",
    "close": "关闭",
    "code_kopieren": "复制代码",
    "code_kopieren_success": "复制代码",
    "confirm_clear_channel_desc": "您想从本地视图中清除该频道吗？",
    "confirm_clear_channel_title": "空通道",
    "confirm_clear_chat": "您想清空此聊天记录吗？",
    "confirm_clear_chat_desc": "您想清空此聊天记录吗？",
    "confirm_clear_chat_title": "空聊",
    "confirm_clear_everyone": "您想清空双方的聊天吗？ （确定=适用于所有人，取消=仅适用于我）",
    "confirm_delete_everyone": "您想删除双方的消息吗？ （确定=适用于所有人，取消=仅适用于我）",
    "confirm_delete_msg": "您想删除此消息吗？",
    "confirm_delete_msg_desc": "您想删除这条聊天消息吗？",
    "confirm_delete_msg_title": "删除留言",
    "confirm_new_password": "确认新密码",
    "copy": "复制",
    "create_btn": "创造",
    "create_channel_title": "创建频道",
    "create_group_is_crisis": "标记为危机区域",
    "create_group_title": "创建新组",
    "crypto_lock_desc": "控制 GaiaCOM 何时从内存中删除本地加密密钥。",
    "crypto_lock_menu_desc": "控制重新加载和不活动计时器。",
    "crypto_lock_title": "密码锁",
    "crypto_session_duration": "重新加载后解锁",
    "crypto_session_duration_desc": "仅在选定的持续时间内在此浏览器选项卡中保持加密会话打开。",
    "cryptographic_fingerprint": "密码指纹",
    "current_password": "当前密码",
    "data_minimization": "数据最小化",
    "decrypt_failed": "无法破译",
    "delete": "删除",
    "delete_account_button": "不可撤销地删除帐户",
    "delete_account_confirm_label": "输入 DELETE 确认",
    "delete_account_confirmation_error": "需要密码和删除确认。",
    "delete_account_desc": "此模式会永久销毁您的帐户、身份、设备会话、GaiaDrop 数据、上传元数据和服务器端归因消息。",
    "delete_account_done_desc": "所有可分配的 GaiaCOM 数据均已删除。",
    "delete_account_done_title": "帐户已删除",
    "delete_account_menu_desc": "销毁帐户和相关数据。",
    "delete_account_not_authenticated": "没有活跃帐户。",
    "delete_account_title": "删除帐户",
    "delete_for_everyone": "为大家删除",
    "delete_for_me": "只为我删除",
    "device_current": "这个装置",
    "device_last_seen": "最后的",
    "device_logout": "退出",
    "device_sessions_desc": "检查活动会话并取消注册您不再信任的设备。",
    "device_sessions_empty": "未找到设备。",
    "device_sessions_menu_desc": "管理和结束活动会话。",
    "device_sessions_title": "注册设备",
    "device_since": "自从",
    "display_name": "显示名称",
    "drop_address_copied": "GaiaDrop 地址已复制。",
    "drop_btn_decrypting": "收件箱正在解密...",
    "drop_btn_load": "加载 GaiaDrop 收件箱",
    "drop_delete_desc": "您真的要永久删除此掉落吗？",
    "drop_delete_title": "删除 GaiaDrop",
    "drop_desc": "用于外部通知、负责任的披露和机密报告的纯文本零知识下降通道。外部各方无需使用您的 GaiaID 帐户即可发送消息。",
    "drop_empty": "尚未加载 GaiaDrop 消息。",
    "drop_id": "掉落ID：",
    "drop_own_address": "您的 GaiaDrop 地址",
    "drop_proof": "防摔",
    "drop_title": "GaiaDrop 安全收件箱",
    "dunkler_modus": "深色模式",
    "e2e_chat_room_open": "开通端到端聊天室",
    "edit_profile": "编辑个人资料",
    "edit_profile_desc": "自定义显示名称、简介和头像。",
    "einladungscode": "邀请码",
    "enter_fingerprint_chars_confirm": "输入要求的指纹字符进行确认。",
    "envelope_hash": "信封哈希",
    "erasability": "可擦除性",
    "erfolg": "成功",
    "exclude_plaintext": "导出无纯文本",
    "export_disclosure": "出口安全案例",
    "export_package_desc": "仅当有意公开时才包含纯文本。",
    "export_package_title": "出口安全包",
    "fehler": "错误",
    "gaiacom_reader": "盖亚COM阅读器",
    "gaiadrop_inbox_title": "GaiaDrop 收件箱",
    "gaiavault": "盖亚金库",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM 最大限度地减少元数据、将私钥保留在本地、端到端加密内容并实现完整帐户删除。",
    "gdpr_home_title": "100% 符合 GDPR",
    "gdpr_reason_delete": "帐户删除会删除帐户、身份、本地会话和服务器端可分配数据。",
    "gdpr_reason_e2ee": "私有内容仅对目标接收者是可解密的。",
    "gdpr_reason_minimal": "元数据仅用于路由、传递和安全凭证。",
    "gdpr_reason_zero_knowledge": "私钥和恢复数据仍由用户控制在本地。",
    "gesendet": "发送",
    "gesperrt_verdaechtig": "禁止/可疑",
    "group_delete_desc": "您真的要永久删除该群组吗？该组中的所有频道和消息都将被删除。",
    "group_delete_title": "删除群组",
    "group_description": "描述",
    "group_icon_label": "组图标/头像",
    "group_name": "团体名称",
    "group_settings_avatar": "阿凡达",
    "group_settings_desc": "描述",
    "group_settings_is_crisis": "标记为危机区域",
    "group_settings_name": "团体名称",
    "group_settings_title": "群组设置",
    "groups_empty_desc": "为项目、危机或团队沟通创建一个安全的工作空间。",
    "groups_empty_title": "还没有群聊",
    "gruppe_beitreten": "已加入群组",
    "gruppe_erstellen": "+ 创建群组",
    "gruppe_verlassen": "离开群组",
    "gruppen_chats": "群聊",
    "heller_modus": "明亮模式",
    "how_to_receive_drops": "我如何接收掉落物？",
    "identitaets_assistent": "身份助理",
    "inactivity_lock_duration": "不活动时锁定",
    "inactivity_lock_duration_desc": "在这段时间没有输入之后，GaiaCOM 将自动被加密锁定。",
    "inactivity_lock_notice": "GaiaCOM 由于不活动而被加密封锁。",
    "include_plaintext": "包含纯文本",
    "invite_code_label": "邀请码",
    "join_group_title": "加入群组",
    "kanaele": "渠道",
    "kanal_erstellen": "+ 频道",
    "kein_chat_ausgewaehlt": "未选择聊天",
    "kein_kanal_ausgewaehlt": "未选择频道",
    "keine_gruppe_ausgewaehlt": "未选择任何组",
    "keine_mails": "没有可用的电子邮件。",
    "key_change_warn_desc": "此联系人的公钥已更改。在信任指纹之前先检查指纹。",
    "key_change_warn_title": "密码警告",
    "key_change_warning_changed": "已经改变了。这可能是中间人攻击的迹象！",
    "key_change_warning_msg": "联系人的身份密钥",
    "key_transparency": "关键透明度",
    "kopiert": "已复制",
    "kryptographische_schluessel": "加密密钥",
    "kryptographische_schluessel_desc": "显示私钥和备份种子短语。",
    "laden": "加载...",
    "leeren": "空的",
    "loading": "加载...",
    "local_key_vault": "本地密钥库",
    "local_keys_label": "本地键",
    "lock_on_reload": "重新加载后始终锁定",
    "logout": "退出",
    "mail_compose": "写电子邮件",
    "mein_profil": "我的个人资料",
    "melden": "报告",
    "menu": "菜单",
    "message": "消息",
    "message_id": "消息ID",
    "message_pin": "别针",
    "message_pinned_title": "固定消息",
    "message_react": "反应",
    "message_reply": "回答",
    "message_replying_to": "回答",
    "message_save": "节省",
    "message_saved": "已保存",
    "message_to_channel": "留言至",
    "message_unpin": "解决",
    "message_unsave": "不保存",
    "mitglied": "成员",
    "mitglieder": "会员",
    "ml_kem": "ML-KEM",
    "neue_mail": "新电子邮件",
    "never_auto_lock": "永远不会自动",
    "new_fingerprint": "新指纹",
    "new_identity": "新身份",
    "new_password": "新密码",
    "no_description": "无描述",
    "no_key_history": "没有记录关键历史记录。",
    "no_specification": "未指定",
    "old_fingerprint": "旧指纹",
    "open_privacy_imprint": "开放印记和数据保护",
    "post_quantum_e2e": "后量子E2E",
    "posteingang": "收件箱",
    "powered_by": "供电",
    "privacy_imprint_menu_desc": "显示 GDPR、数据保护和法律声明。",
    "privacy_imprint_profile_desc": "GaiaCOM按照数据最小化、端到端加密和本地密钥控制的原则处理通信内容。",
    "privacy_imprint_title": "数据保护和法律声明",
    "profil": "轮廓",
    "profile_details": "个人资料详情",
    "profile_settings_hint": "配置文件设置显示在右侧面板中。",
    "profile_unlock_desc": "出于安全原因，您必须重新输入密码才能查看您的私有密钥。",
    "proof_hash": "证明哈希：",
    "public_drop_desc": "无需 GaiaCOM 帐户即可安全投递外部文本信息。",
    "public_drop_message": "消息",
    "public_drop_message_placeholder": "输入机密文本...",
    "public_drop_send": "发送 GaiaDrop",
    "public_drop_sender": "发件人备注可选",
    "public_drop_sender_placeholder": "姓名、档案号或匿名",
    "public_drop_target": "目标GaiaID",
    "quanten_chat": "量子聊天",
    "quantum_secure_exchange": "量子安全交换通过...",
    "quantum_secure_net": "GaiaCOM 量子安全网络（Ed25519 和 ML-KEM）",
    "quantum_shield_desc": "GaiaCOM 网络通过多层混合加密协议保护您的隐私，防止未来量子计算机的攻击。",
    "quantum_shield_l1_desc": "使用FIPS 203标准封装对称共享密钥。防止量子计算机进行被动记录和稍后解密（“立即存储，稍后解密”）。",
    "quantum_shield_l1_title": "1. 后量子保护（ML-KEM-1024）",
    "quantum_shield_l2_desc": "经典、极快的 Diffie-Hellman 密钥交换过程，可作为混合过程中的附加安全层。",
    "quantum_shield_l2_title": "2.椭圆曲线密码学（X25519）",
    "quantum_shield_l3_desc": "每条消息和每个联邦信封都经过加密签名，以明确验证发件人的真实性。",
    "quantum_shield_l3_title": "3. 数字签名 (Ed25519)",
    "quantum_shield_l4_desc": "对称加密消息内容，并将发送者、接收者和元数据紧密绑定到经过身份验证的附加数据 (AAD)，以防止重放攻击。",
    "quantum_shield_l4_title": "4.AAD认证（AES-256-GCM）",
    "quantum_shield_status": "量子护盾状态",
    "receive_drops_step1": "与外部来源共享您的 GaiaID（例如使用上面的复制按钮）。",
    "receive_drops_step2": "这些会调用 GaiaCOM 实例的登录页面并切换到选项卡",
    "receive_drops_step3": "并将他们的加密消息发送到您的地址。",
    "receiver_gaia": "GaiaCOM接收器",
    "receiver_smtp": "SMTP 收件人",
    "records_stored": "已保存记录",
    "refresh": "更新",
    "report_abuse_desc": "您想报告此消息并向服务器提交滥用的加密证据吗？",
    "report_abuse_title": "举报滥用行为",
    "reputation_status": "声誉状况",
    "room_chat_start_hint": "开始对话！该群组通道中的所有消息均经过去中心化量子安全端到端加密。",
    "room_policy_audit": "审计跟踪和密钥轮换处于活动状态。",
    "room_policy_crisis": "危机室",
    "room_policy_e2ee": "零知识空间。 E2EE量子安全。",
    "room_policy_title": "房间指南",
    "room_policy_zero_knowledge": "政策",
    "room_security_note_desc": "所有关键更改均通过关键透明度进行验证。使用 GaiaVault 进行私人备份日志。",
    "room_security_note_title": "固定的安全说明",
    "save_profile": "保存个人资料",
    "schluessel_entsperrt": "🔑 再次锁定钥匙",
    "search_gaia_label": "查找盖亚地址",
    "security_warning_title": "安全警告",
    "select_channel_chat": "从左侧边栏中选择一个频道进行聊天。",
    "select_contact_chat": "从左侧面板中选择联系人以开始量子安全的端到端聊天。",
    "select_mail_read": "从列表中选择一封电子邮件以阅读其量子安全内容或创建新消息。",
    "senden": "发送",
    "sender_signature": "发件人签名",
    "server_log": "服务器日志：",
    "server_received": "服务器已收到",
    "session_lock": "会话锁定",
    "setup_address_keys": "创建地址和密钥集",
    "setup_profile": "在个人资料中设置",
    "smtp_inbox_title": "SMTP接收",
    "smtp_legacy_badge": "旧版 SMTP/不安全",
    "smtp_mode_option": "旧版 SMTP 桥",
    "smtp_security_warning": "这封电子邮件是通过经典的、未加密的 SMTP 协议传输的。没有启用端到端加密。",
    "smtp_security_warning_desc": "此消息正在离开 GaiaCom 安全室。 SMTP 传送不提供 GaiaCom 本地端到端保证，没有 TrustMesh 保证，也没有来自网关的 Godmode 保证。",
    "spam_verdacht": "垃圾邮件/可疑邮件",
    "spam_warning_desc": "此消息具有可疑的信誉信号。",
    "spam_warning_title": "垃圾邮件警告",
    "speichern": "节省",
    "sperren": "锁定",
    "standard_group_status": "标准群聊（E2EE加密）",
    "status": "地位",
    "subject": "关于",
    "suchen": "寻找新的盖亚地址...",
    "tage": "天",
    "time_unknown": "时间未知",
    "transmission_mode": "传输方式",
    "trust_age": "信托年龄",
    "trust_passport_title": "信托护照",
    "unbestaetigt": "未证实",
    "unknown_sender": "未知",
    "unlock_btn": "开锁",
    "unlock_btn_profile": "开锁",
    "unlock_desc": "您的私钥文件是加密存储的。输入您的密码以仅将加密密钥加载到内存中。",
    "unlock_logout": "注销并关闭本地密钥",
    "unlock_title": "解锁身份",
    "untrusted": "不值得信赖",
    "update_password": "更新密码",
    "upload_avatar_btn": "上传图片（已消毒）",
    "vault_btn_encrypt": "加密记录",
    "vault_btn_lock": "锁保险箱",
    "vault_btn_unlock": "解锁保险箱",
    "vault_copied_success": "已复制到剪贴板",
    "vault_decrypted_content": "解密内容",
    "vault_desc": "用于恢复备份、身份说明、服务器访问、紧急联系人、法律说明、安全事件和私人日志的本地加密保管库。",
    "vault_empty": "尚未保存安全记录。",
    "vault_locked_pane_notice": "保险箱已锁。请在右侧解锁。",
    "vault_new_record": "新的安全记录",
    "vault_pwd_placeholder": "输入保管库密码...",
    "vault_record_body": "记录内容",
    "vault_record_body_placeholder": "输入加密的记录内容...",
    "vault_record_category": "类别",
    "vault_record_title": "记录标题",
    "vault_record_title_placeholder": "安全记录的标题",
    "vault_title": "GaiaVault 安全记录",
    "verify_new_fingerprint_hint": "在接受密钥之前检查新指纹。",
    "vertrauenswuerdig": "值得信赖",
    "vision_gaia_technology": "愿景盖亚科技",
    "von": "从",
    "warnung": "警告",
    "wizard_address": "地址",
    "wizard_back": "后退",
    "wizard_check1": "我已经安全地保存了我的种子。",
    "wizard_custom_domain": "使用您自己的域名",
    "wizard_desc1": "GaiaCOM 不在服务器端存储私钥。如果没有助记词种子，任何人都无法恢复丢失的消息。",
    "wizard_desc2": "您的地址决定了加密信封通过的联合节点的路由。",
    "wizard_fallback": "后备节点",
    "wizard_finish": "完成设置",
    "wizard_next": "更远",
    "wizard_server_domain": "服务器节点域",
    "wizard_step1": "1. 备份种子",
    "wizard_step2": "2. 地址及服务器",
    "wizard_title1": "备份恢复密钥",
    "wizard_title2": "选择GaiaCOM地址",
    "write_message_placeholder": "写一条安全消息...",
    "you": "你",
    "zero_knowledge": "零知识",
    "zero_knowledge_encryption": "零知识加密",
    "Chat fuer alle geleert": "Der Chat wurde für alle Teilnehmer geleert.",
    "Chat geleert": "Der Chat wurde für deine lokale Inbox geleert.",
    "Nachricht fuer alle geloescht": "Die Nachricht wurde für alle Teilnehmer gelöscht.",
    "Nachricht geloescht": "Die Chat-Nachricht wurde lokal aus deiner Inbox entfernt.",
    "anpinnen": "Anpinnen",
    "chat_loeschen": "Chat löschen",
    "confirm_delete_chat_desc": "Möchtest du den Chat wirklich löschen und ausblenden?",
    "confirm_leave_group_desc": "Möchtest du diese Gruppe wirklich verlassen?",
    "entpinnen": "Entpinnen",
    "group_deleted": "Gruppe erfolgreich gelöscht.",
    "group_left": "Gruppe erfolgreich verlassen.",
    "gruppe_loeschen": "Gruppe löschen",
    "loeschen": "Löschen",
    "no_active_chats": "Keine aktiven Chats. Suche oben nach Kontakten, um einen Chat zu starten.",
    "pinned": "Angepinnt",
    "wizard_check_credentials": "我有责任保证我的访问数据的安全。",
    "wizard_check_is_beta": "据我所知，GaiaCom 是测试版软件。",
    "wizard_check_no_illegal": "我不会将 GaiaCom 用于非法目的。",
    "wizard_check_no_uptime": "我了解无法保证可用性。",
    "wizard_check_smtp_security": "我了解 SMTP 消息不提供完整的 GaiaCom 安全性。",
    "wizard_check_terms_read": "我已阅读 Beta 服务条款。",
    "wizard_step_terms": "使用条款",
    "wizard_terms_text": "GaiaCom 使用条款和 Beta 测试协议（Beta 阶段）\n\n提供商：VisionGaiaTechnology（以下简称“提供商”）\n状态：公开 Beta 测试阶段\n有效期：2026年6月21日起\n\n⚠️ 最重要的提前说明（请仔细阅读）\nGaiaCom 正处于公开 Beta 测试阶段。尽管采取了广泛的安全措施，但仍无法保证软件和底层基础设施的无错误、持续可用性或绝对安全。使用风险自负。用户有责任安全存储其访问数据（尤其是 GaiaVault 的密钥）并遵守适用的法律。\n\n1. Beta测试阶段的主题和目的\n1.1.提供目的：GaiaCom 是一种基于后量子密码学 (PQC) 的新型电子邮件和聊天服务。测试阶段的规定专门用于技术测试、负载模拟、查找程序错误（bug）和优化用户友好性。\n1.2.测试版状态：用户知道所提供的软件是初步版本（测试版软件）。这在技术上尚未完全开发，不符合最终商业产品的标准，并且可能导致错误、数据丢失、传输延迟或系统崩溃。\n1.3.无继续权利：提供商有权随时全部或部分中断服务、更改或限制功能或暂时或永久删除服务，而无需说明理由。\n\n2. 可用性和免责声明\n2.1.无可用性保证：GaiaCom 不提供任何可用性或正常运行时间保证。没有权利不间断地提供服务。\n2.2.保修排除：软件按当前状态（“原样”）提供，并视供应情况而定。在法律允许的范围内，不对软件中的材料和法律缺陷提出任何保修索赔。特别是，无法保证该软件没有错误、没有恶意软件或适合特定用途。\n\n3. 风险管理和用户义务\n3.1.禁止存储关键数据：用户承诺不专门通过 GaiaCom 存储或传输任何业务关键、重要、操作必需或法律上特别敏感的数据（例如患者档案、高度敏感的财务数据或官方监管的秘密）。该服务不得用于不可预见的故障可能导致人身伤害、财产损失或重大财务损失的基础设施。\n3.2.自行负责的备份：用户负责在自己的独立系统上备份他长期需要的通过 GaiaCom 接收或发送的所有数据（备份副本）。提供商不保证其服务器上数据的永久存储或可恢复性。\n\n4. 加密功能和GaiaVault\n4.1.后量子密码学 (PQC)：GaiaCom 实施最先进的、面向未来的加密流程，旨在抵御未来量子计算机的攻击。然而，用户意识到这是一个充满活力的新科学领域。以目前的科学技术水平无法保证绝对的、无可辩驳的安全。明确不保证“100% 安全”、“不可破解”或“军事安全”等术语。\n4.2.无恢复保证（GaiaVault）：GaiaCom 依赖一致的零知识安全概念。加密楔子和访问数据仅由用户控制（通过 GaiaVault 保护）。\n重要提示：如果用户丢失密码、密码、私钥或恢复种子，提供商没有技术能力重建或重置此数据。这些访问数据的丢失将不可避免地导致用户帐户及其中所有加密数据的访问权限不可挽回地丢失。\n4.3.尚未全面审核：该软件持续接受内部安全检查，但在测试阶段尚未接受独立测试机构最终、全面的外部安全审核。\n\n5. 接口、遗留协议和联合\n5.1. SMTP 桥 注意：GaiaCom 提供通过经典电子邮件协议（例如 SMTP）进行通信的能力。用户知道离开本地 GaiaCom 安全区域的消息（例如，当发送到传统的 @gmail.com 或 @gmx.de 地址时）是通过未加密的或第三方服务器传输的。 GaiaCom 的端到端安全保证仅在有限范围内适用或根本不适用于此类传出或外部传入的旧消息。\n5.2.联盟注意：如果 GaiaCom 在联盟网络上运行，消息和数据可能会通过第三方服务器传递。虽然消息内容仍然受到端到端加密的保护，但元数据（例如发送时间、所涉及服务器的 IP 地址和收件人地址）在技术上可能对这些联合服务器的运营商可见。提供商对联合网络中第三方服务器运营商的数据保护实践没有影响。\n\n6. 可接受的用途和禁止的活动\n用户承诺不以不当或非法目的使用本服务。特别禁止以下行为：\n- 分发、发送或托管病毒、恶意软件、网络钓鱼内容或其他恶意软件。\n- 使用本服务进行拒绝服务攻击 (DDoS) 或未经请求的批量邮件（垃圾邮件）。\n- 滥用系统进行欺诈。\n- 传播或交换非法内容，特别是对儿童性虐待 (CSAM) 的描述、恐怖主义宣传、呼吁暴力或其他与犯罪相关的内容。\n\n7. 滥用举报系统\n7.1.举报滥用行为：用户有机会通过综合滥用系统举报滥用通信或非法活动。\n7.2.报告处理：为了确保防止滥用，可以对传入的报告进行技术分析（同时保持隐私和加密限制）。如果经证实违反这些使用条款，这可能会导致用户帐户或 IP 地址暂时或永久暂停。\n\n8. 责任限制\n8.1.责任标准：测试版软件免费提供。因此，根据捐赠或贷款的法律规则，提供者仅对故意（故意损害）和重大过失承担责任。\n8.2.数据丢失责任的免除：除非丢失是由提供商故意或重大过失造成的，并且用户已履行通过定期备份（GaiaCom 之外）减轻损害的义务，否则不承担数据丢失的责任。\n8.3.法律限制：上述责任限制不适用于对生命、身体或健康的伤害或《产品责任法》规定的责任。\n\n9. 开源\n某些 GaiaCom 组件、库或客户端应用程序可能会根据开源许可证（例如 GPL、MIT、Apache）获得许可。这些组件各自的许可条款不受这些使用条款的影响，并且可以在相应的源代码存储库中查看。\n\n10. 出口管制和合规\n用户知道加密软件可能受到严格的出口管制和法律限制。用户有责任确保 GaiaCom 的使用不违反其各自居住国的法律、进出口限制或密码法规。\n\n11. 数据保护声明（测试版简短版本）\n11.1.最少的数据收集：作为测试阶段的一部分，提供商仅收集技术操作、故障排除和进一步开发绝对必要的数据（例如用于错误诊断的服务器日志文件）。\n11.2.无法洞察内容：由于一致的零知识和端到端加密，提供商永远无法访问您存储在 GaiaVault 中的聊天内容、电子邮件或密钥。\n11.3。详细的数据保护声明：详细的数据保护规定单独链接，用户在注册前也必须考虑。\n\n12. 最终条款\n12.1。适用法律：适用德意志联邦共和国法律，但不包括《联合国国际货物销售合同公约》。\n12.2.可能会发生变化：由于 GaiaCom 正在积极开发中，提供商保留随时调整这些条件并在未来生效的权利。当前版本可在应用程序中找到。",
    "wizard_terms_title": "GaiaCom 使用条款和 Beta 测试协议（Beta 阶段）",
    "node_operator": "节点运营商",
    "search_channels": "搜索频道...",
    "senior_reviewer": "高级审稿人",
    "trusted_reviewer": "值得信赖的审稿人",
    "active_frequencies": "活动频率",
    "connected_rooms": "互联空间",
    "dashboard": "仪表板",
    "empty_chats": "没有可用的活跃聊天。",
    "empty_messages": "没有新消息可用。",
    "encrypted": "加密的",
    "gaiacom_uplink": "盖亚康上行链路",
    "install_app": "安装应用程序",
    "install_app_desc": "用于快速启动和离线模式",
    "kommandozentrale_alpha": "阿尔法指挥中心",
    "network_online": "网络：在线",
    "new_room": "新空间",
    "no_frequencies_active": "没有活动频率。创建一个新房间开始沟通。",
    "no_id": "无身份证件",
    "open_chats": "打开聊天室",
    "open_inbox": "打开收件箱",
    "primary_identity": "主要身份",
    "recent_chats": "新聊天记录",
    "recent_messages": "最新消息",
    "session_encrypted": "会话已加密：{name}",
    "session_secure": "状态：安全",
    "system_verlassen": "退出系统",
    "write_message": "写留言",
    "onboarding_step_profile": "个人资料",
    "onboarding_step_security": "安全保护",
    "onboarding_step_backup": "备份数据",
    "onboarding_step_launch": "启动",
    "onboarding_loading_gaia_id": "正在加载 Gaia-ID",
    "onboarding_setup_kicker": "GaiaCom 初始设置",
    "onboarding_profile_title": "打造专属您的 GaiaCom 空间。",
    "onboarding_profile_desc": "您的显示名称和头像保存在本地，可随时在个人资料中进行修改。",
    "onboarding_security_title": "GaiaCom 正在为您保护的内容。",
    "onboarding_security_desc": "GaiaCom 隔离了身份、密钥、消息和网络状态。此处仅显示简短的用户说明。",
    "onboarding_backup_title": "备份是您真正的紧急出口。",
    "onboarding_backup_desc": "没有恢复数据，任何人都无法挽救您的身份。这正是真正端到端安全的意义所在。",
    "onboarding_launch_title": "准备就绪。您想先做什么？",
    "onboarding_launch_desc": "您可以直接开始，也可以结束导览并继续在控制面板中工作。",
    "onboarding_display_name": "显示名称",
    "onboarding_display_name_placeholder": "您希望 GaiaCom 如何显示您的名称？",
    "onboarding_select_avatar": "选择头像",
    "onboarding_sec_identity_title": "身份认证",
    "onboarding_sec_identity_desc": "您的 Gaia-ID 是您的网络锚点。联系人可以检测到密钥的更改。",
    "onboarding_sec_messages_title": "安全消息",
    "onboarding_sec_messages_desc": "内容在本地解密。编辑后的消息将获得新的签名。",
    "onboarding_sec_network_title": "网络安全",
    "onboarding_sec_network_desc": "安全中心和滥用申诉中心让风险清晰可见，无任何全局后门。",
    "onboarding_sec_transparency_title": "公开透明",
    "onboarding_sec_transparency_desc": "将安全相关事件写入日志，确保警告信息可追溯。",
    "onboarding_backup_notice_title": "普通用户重要提示",
    "onboarding_backup_notice_desc": "请将您的恢复数据与此设备分开保存。若丢失密码和备份，GaiaCom 将故意保持锁定状态且无法恢复。",
    "onboarding_backup_consent": "我知道我的备份对于数据恢复和更换设备至关重要。",
    "onboarding_inbox_title": "收件箱",
    "onboarding_inbox_desc": "阅读邮件并撰写您的第一封信。",
    "onboarding_contacts_title": "联系人",
    "onboarding_contacts_desc": "验证首个联系人或启动安全聊天。",
    "onboarding_channels_title": "公共频道",
    "onboarding_channels_desc": "探索公共频道频率。",
    "onboarding_security_title_card": "安全中心",
    "onboarding_security_desc_card": "查看 GaiaShield 安全状态。",
    "onboarding_later": "稍后",
    "onboarding_back": "返回",
    "onboarding_continue": "继续",
    "onboarding_complete_setup": "完成设置",
    "auth_legal_consent": "我已阅读并同意隐私政策和使用条款。",
    "auth_show_terms": "显示使用条款",
    "auth_recovery_mode": "恢复模式",
    "auth_recovery_import_title": "导入恢复文件",
    "auth_recovery_import_desc": "从受密码保护的备份文件中恢复您的 GaiaCom 密钥。之后，助记词和用户名将自动填充。",
    "auth_recovery_file_pwd_placeholder": "恢复文件密码",
    "auth_recovery_local_pwd_placeholder": "新本地解锁密码（最少 12 个字符）",
    "auth_recovery_importing": "正在导入...",
    "auth_recovery_decrypt": "解密恢复数据",
    "auth_back_to_login": "返回登录",
    "auth_terms_title": "GaiaCom Beta 使用条款",
    "auth_terms_close": "关闭",
    "auth_cookie_title": "GaiaCOM 保持主权自主。",
    "auth_cookie_desc": "我们仅使用技术上必需的本地存储来保存语言、会话和安全设置。无任何追踪、广告 Cookie 或第三方画像。",
    "auth_cookie_accept": "我知道了",
    "sc_explainer_title": "这里实际保护的是什么？",
    "sc_explainer_desc": "GaiaShield 是您的账户、消息与网络之间的保护层。它不审查内容，而是防范技术风险：篡改、重放攻击、越权访问、异常登录模式和不安全的网关转换。",
    "sc_explainer_identity_desc": "检测登录异常、会话风险以及对他人身份的访问。",
    "sc_explainer_messages_desc": "识别重放模式、篡改的信封和缺失的完整性特征。",
    "sc_explainer_network_desc": "在错误显示信任前，标记联盟、速率限制和 SMTP 风险。",
    "sc_open_security_warnings": "待处理的安全警告",
    "sc_opt_all": "全部",
    "sc_opt_low": "低级",
    "sc_opt_medium": "中级",
    "sc_opt_high": "高级",
    "sc_opt_critical": "紧急",
    "sc_opt_failed_login": "登录失败",
    "sc_opt_auth_attack": "身份认证攻击",
    "sc_opt_rate_limit": "速率限制",
    "sc_opt_policy_violation": "安全策略提示",
    "sc_opt_message_replay": "消息重放攻击",
    "sc_node_security_data_unavailable": "节点安全数据不可用",
    "sc_total_events": "事件总数",
    "sc_login_attacks": "登录攻击次数",
    "sc_rate_limits_active": "当前速率限制数",
    "sc_smtp_shield_hits": "SMTP Shield 命中数",
    "sc_top_event_categories": "主要事件类别",
    "sc_no_entries": "暂无记录。",
    "sc_node_audit_log": "节点审计日志（最近事件）",
    "sc_no_node_events": "暂无节点事件。",
    "archiv": "归档",
    "entwuerfe": "草稿",
    "markiert": "星标",
    "wichtig": "重要",
    "snoozed": "已延后",
    "papierkorb": "废纸篓",
    "spam": "垃圾邮件",
    "cancel": "取消",
    "error": "错误",
    "success": "成功",
    "kopieren": "复制",
    "block_contact": "阻止联系人",
    "unblock_contact": "取消阻止联系人",
    "report_contact": "举报联系人",
    "check_fingerprint": "验证指纹",
    "export_encrypted": "导出 (已加密)",
    "export_gaiaproof": "导出 (GaiaProof)",
    "export_password_prompt": "请输入用于加密聊天导出的密码：",
    "export_success": "聊天导出并加密成功。",
    "export_failed": "导出失败：",
    "gaiaproof_export_success": "GaiaProof 数据包导出成功。",
    "gaiaproof_export_failed": "GaiaProof 导出失败：",
    "export_gaiaproof_confirm": "是否要下载包含所有签名和服务器传送收据的 GaiaProof 数据包？这可能需要一点时间。",
    "group_settings_is_private": "私密房间 (不可公开搜索，仅限申请加入)",
    "group_settings_read_only": "只读模式 (仅创建者和管理员可发送消息)",
    "group_settings_slow_mode": "慢速模式 (发送冷却)",
    "gsn_title": "GSN 社交动态",
    "gsn_node_feed": "节点动态",
    "gsn_following_feed": "正在关注",
    "gsn_feed_empty": "未找到帖子。",
    "gsn_composer_placeholder": "联邦里有什么新鲜事？",
    "gsn_post_btn": "分享",
    "gsn_profile": "用户资料",
    "gsn_followers": "粉丝",
    "gsn_following": "正在关注",
    "gsn_bio": "描述 / 简介：",
    "gsn_bio_label": "描述 / 简介",
    "gsn_display_name": "显示名称",
    "gsn_edit_profile": "编辑个人资料",
    "gsn_save_profile": "保存",
    "gsn_add_image": "添加图片 (已加密)",
    "gsn_add_emoji": "插入表情符号",
    "gsn_avatar_emoji": "头像 (表情)",
    "gsn_follow": "关注",
    "gsn_unfollow": "取消关注",
    "gsn_repost": "分享 / 转发",
    "gsn_post_created": "帖子分享成功。",
    "gsn_image_uploaded": "图片已加密并上传。",
    "gsn_upload_failed": "图片上传失败：",
    "gsn_comment_placeholder": "写评论...",
    "gsn_delete_confirm_title": "删除帖子？",
    "gsn_delete_confirm_desc": "您确定要永久删除此帖子吗？",
    "gsn_delete_comment_confirm_title": "删除评论？",
    "gsn_delete_comment_confirm_desc": "您确定要永久删除此评论吗？",
    "gsn_report": "举报",
    "gsn_report_title": "举报违规",
    "gsn_report_category": "类别",
    "gsn_report_spam": "垃圾内容 / 广告",
    "gsn_report_harassment": "骚扰 / 仇恨言论",
    "gsn_report_abuse": "滥用",
    "gsn_report_illegal": "违法内容",
    "gsn_report_severity": "严重性",
    "gsn_report_low": "低",
    "gsn_report_medium": "中",
    "gsn_report_high": "高",
    "gsn_report_comment": "附加说明",
    "gsn_report_submit": "举报",
    "gsn_report_submitted": "举报已提交给治理委员会。",
    "gsn_report_post": "举报帖子",
    "report_group": "举报群组",
    "report_group_reason_prompt": "请输入举报原因 (可选)：",
    "report_reason_prompt": "请输入举报原因 (可选)：",
    "report_failed": "举报失败：",
    "report_success": "联系人举报成功。",
    "room_read_only_placeholder": "仅限创建者和管理员可写",
    "read_only_active": "只读模式",
    "slow_mode_active": "慢速模式已启用",
    "kommandozentrale": "控制中心",
    "kontakt_blockiert": "联系人已阻止",
    "kontakt_freigegeben": "联系人已取消阻止",
    "mailbox_settings_title": "邮箱设置",
    "mailbox_settings_desc": "管理签名、语言、邮件过滤器。",
    "mic_access_denied": "麦克风访问被拒绝：",
    "no_frequencies_active_desc": "创建一个新房间以开始交流。",
    "key_changed_warning_title": "安全告示：",
    "key_changed_warning_desc": "此发件人的身份密钥已更新，或者与之前已知的密钥不同。请通过其他安全渠道验证指纹。",
    "sc_col_category": "类别",
    "search_members": "搜索成员...",
    "tab_general": "常规",
    "tab_members": "成员",
    "tab_requests": "请求",
    "tab_invites": "邀请",
    "tab_logs": "日志",
    "auth_why_gaiacom": "为什么选择 GaiaCOM？",
    "auth_why_gaiacom_desc": "用于机密通信的安全、去中心化替代方案。",
    "auth_self_managed_id": "自主管理 ID",
    "auth_self_managed_id_desc": "无需提供电子邮件或电话号码即可立即创建安全的加密身份。",
    "auth_gaiadrop_secure_exchange": "无需账号的安全交换",
    "auth_gaiadrop_benefit_e2ee": "端到端加密",
    "auth_gaiadrop_benefit_no_login": "无需登录",
    "auth_gaiadrop_benefit_inbox": "直接投递到接收者的收件箱",
    "auth_terms_of_use": "使用条款",
    "auth_terms_of_use_show": "显示使用条款",
    "auth_consent_privacy_terms": "我已阅读并同意隐私政策和使用条款。",
    "auth_recovery_import_file": "导入恢复文件",
    "auth_recovery_password": "恢复文件密码",
    "auth_recovery_local_password": "新的本地解锁密码 (最少 12 个字符)",
    "auth_recovery_decrypting": "正在解密恢复数据...",
    "auth_recovery_back": "返回登录",
    "auth_cookie_sovereign": "GaiaCOM 保持主权自主。",
    "auth_cookie_sovereign_desc": "我们仅使用技术上必需的本地存储功能来保存语言、会话和安全设置。无追踪，无广告 Cookie，无第三方画像。",
    "auth_cookie_sovereign_accept": "明白了",
    "unlock_keyboard_toggle": "⌨️ 使用键盘",
    "unlock_keypad_toggle": "🔢 使用 PIN 键盘",
    "unlock_status_denied": "拒绝访问 / 重试",
    "unlock_status_decrypting": "正在解密安全库...",
    "unlock_status_secured": "安全库已锁定",
    "auth_landing_nav_legal": "法律信息",
    "auth_landing_nav_beta": "测试版",
    "auth_landing_card1_title": "后量子加密 (ML-KEM)",
    "auth_landing_card2_title": "100% 去中心化",
    "auth_landing_card3_title": "零知识证明",
    "auth_landing_card4_title": "元数据保护",
    "auth_landing_card5_title": "自主管理身份",
    "auth_landing_hybrid_title": "当下的密码学，守护未来的安全。",
    "auth_landing_hybrid_desc": "GaiaCom 结合了经受检验的传统密钥交换与后量子密钥封装，提供深度防御，而非盲目抉择。",
    "auth_landing_x25519_desc": "适用于当今设备与安全会话的快速、可靠的椭圆曲线密钥交换。",
    "auth_landing_mlkem_desc": "后量子密钥封装，提供长期机密性，防御“先收集后解密”的威胁场景。",
    "auth_landing_cycle_title": "服务器一无所知，网络中仅传输加密噪声。",
    "auth_landing_step1_title": "本地加密",
    "auth_landing_step1_desc": "邮件在发送者的设备上完成加密，随后才进入网络或服务器。",
    "auth_landing_step2_title": "封装为数据块",
    "auth_landing_step2_desc": "数据包作为密码学噪声，穿过联合节点或去中心化存储层。",
    "auth_landing_step3_title": "联合存储",
    "auth_landing_step3_desc": "没有作为攻击目标的中央收件箱。数据处于分块、联合且完全加密的状态。",
    "auth_landing_step4_title": "本地解密",
    "auth_landing_step4_desc": "只有接收者的私钥能够将加密噪声还原为可读的内容。",
    "auth_landing_trinity_title": "一个协议概念，三层基础设施结构。",
    "auth_landing_enterprise_desc": "适用于企业、律所、中型商家、工业以及私人银行。提供具备行政控制、合规性与支持的封闭通信圈。",
    "auth_landing_enterprise_list1": "内部主权与用户管理",
    "auth_landing_enterprise_list2": "自托管节点或托管的主权集群",
    "auth_landing_enterprise_list3": "SLA、技术支持与高级模块",
    "auth_landing_network_desc": "保障数字隐私的开放网络。无数据交易，旨在提供自由、加密通信的基础设施。",
    "auth_landing_network_list1": "开源客户端",
    "auth_landing_network_list2": "联合节点",
    "auth_landing_network_list3": "无中央解密密钥",
    "auth_landing_defend_desc": "专为官方机构、关键基础设施和隔离通信环境设计的高安全度专用基础设施。",
    "auth_landing_defend_list1": "物理隔离（air-gapped）与断网部署",
    "auth_landing_defend_list2": "白标定制与源代码审计",
    "auth_landing_defend_list3": "国家数字主权",
    "auth_landing_gov_title": "开放协议，商业运作，明确的法律界限。",
    "auth_landing_gov_desc": "GaiaCom 将开放协议、开源客户端与商业化高级基础设施分离。信任源于透明；收益源于企业运营、支持、集成与专用模块。",
    "auth_landing_price1_desc": "在移动应用商店分发时，用于防范机器人的单次费用。",
    "auth_landing_price2_desc": "面向倾向于自行编译的用户的免费开源版本。",
    "auth_landing_price3_desc": "面向中型企业、律师事务所和保密团队。",
    "auth_landing_price4_desc": "面向集团公司、高可用性集群、LDAP 和超级管理员访问。",
    "auth_landing_license1_desc": "为用户、分支版本及社区审计提供最高程度的代码透明度。",
    "auth_landing_license2_desc": "Copyleft 保护，防范云端侵占与闭源协议分支的出现。",
    "auth_landing_license3_desc": "LDAP、超级管理员、审计、SLA 与专用业务逻辑解决方案。",
    "auth_landing_final_title": "基于零信任模型的通信模式。",
    "auth_landing_final_desc": "GaiaCom 不单是电子邮件的替代品。它引发人们的思考：为何在后量子迁移的当下，机密通信仍依赖易被读取的服务器和 40 年前的陈旧设定。",
    "auth_landing_final_note": "注：本页面介绍的是架构设想与产品路线图。在投入生产使用前，安全承诺必须通过具体实现和审计予以验证。"




  };

export default zh;